<template>
  <div class="page-table page-work-warp">
    <div class="page-search">
      <a-col
        v-for="(nvaList,index) in nvaList"
        :key="index"
        class="navtabs"
        :class="'navtab'+index"
        @click="jumptorepaire(nvaList.status)"
        :style="navspan"
      >
        <div class="img"></div>
        <div class="content">
          <p>{{nvaList.key}}</p>
          <div class="mums">{{nvaList.value}}</div>
        </div>
      </a-col>
    </div>
    <a-row class="thistopnav">
      <div class="table-operator">
        <!-- 表格 -->
        <div class="page-search" style="margin-bottom:0">
            <a-row>
              <a-col class="warp-title" :span="24">不满意的报修单</a-col>
            </a-row>
        </div>
        <standard-table :columns="columns" :dataSource="dataSource" :pagination="PAGINATION" @change="onChange"/>
      </div>
      <div class="table-operator">
        <div class="page-search" style="margin-bottom:0">
          <a-row>
            <a-col class="warp-title" :span="24">维修时长</a-col>
          </a-row>
        </div>
        <standard-table :columns="columns2" :dataSource="dataSource2" :pagination="PAGINATION2" @change="onChange2"/>
      </div>
    </a-row>
    <a-row class="thistopnav">
      <div class="table-operator">
        <div class="page-search">
          <a-form :form="stasetForm" style="width:100%;">
            <a-row>
              <a-col class="warp-title" :span="18">报修单状态占比</a-col>
              <!-- <a-col :span="6">
                <a-form-item style="padding-left:20px">
                  <a-select
                    allowClear
                    :options="tabtimes2"
                    placeholder="全部"
                    @change="stasetFormChange2"
                    v-decorator="['time']"
                  />
                </a-form-item>
              </a-col> -->
            </a-row>
          </a-form>
        </div>
        <div class="btndivright">
          <a-button @click="seeMore('stasetForm')">查看明细</a-button>
        </div>
        <div id="staseChart" :style="{width: '100%', height: '400px'}"></div>
      </div>
      <div class="table-operator" style="min-height: 504px">
        <div class="page-search" style="margin-bottom: 0px">
          <a-row style="width:100%;">
            <a-col class="warp-title" :span="12">维修人员{{columnsType === 1 ? '接单情况' : columnsType === 2 ? '完成度' : '满意度' }}</a-col>
            <a-col class="zbb" :span="12">
              <a-button class="btn" :class="{'active': columnsType === 1}" @click="editansave(1)" >接单量</a-button>
              <a-button class="btn" :class="{'active': columnsType === 2}" @click="editansave(2)" >完成度</a-button>
              <a-button class="btn" :class="{'active': columnsType === 3}" @click="editansave(3)" >满意度</a-button>
            </a-col>
          </a-row>
        </div>
        <!-- <div id="fullChart" :style="{width: '100%', height: '400px'}"></div> -->
        <standard-table rowKeys="name" v-show="columnsType === 1" :columns="columns3" :dataSource="dataSource3"/>
        <standard-table rowKeys="name" v-show="columnsType === 2" :columns="columns4" :dataSource="dataSource4"/>
        <standard-table rowKeys="name" v-show="columnsType === 3" :columns="columns5" :dataSource="dataSource5"/>
      </div>
    </a-row>
    <!-- 查看流程弹框 -->
    <a-modal
      class="lcmodal"
      destroyOnClose
      :maskClosable="false"
      :title="`流程说明`"
      v-model="visibleprease"
      :footer="null"
    >
      <p style="font-size: 16px;color: #3094f9">
        报修单号：{{bxdh}}
        <span style="float: right;">{{currentRowStatusText}}</span>
      </p>
      <div v-for="(lcData,index) in preaseData.list" :key="index">
        <p>{{index+1}}、{{lcData.clms}}</p>
        <div class="lcpicdiv" v-if="lcData.picList && lcData.picList != []">
          <img v-for="(piclist,index) in lcData.picList" :key="index" :src="piclist.fileFullName" />
        </div>
        {{lcData.createDate}}
      </div>

      <a-form v-if="preaseData.yqList && preaseData.yqList.length > 0">
        <a-form-item label="延单说明" :labelCol="{span: 4}" :wrapperCol="{span: 20}">
          <div v-for="(preaseData,ind) in preaseData.yqList" :key="ind">
            <p>{{preaseData.bz}}</p>
            {{preaseData.createDate}}
          </div>
        </a-form-item>
      </a-form>
      <div class="mydiyfooter">
        <a-button @click="handleSubmitprease" type="primary">确定</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import './work.less'
export default {
  name: 'QueryList',
  data () {
    const columns = [
      {
        title: '序号',
        dataIndex: '_index',
        align: 'center'
      },
      {
        title: '单号',
        width: 120,
        align: 'center',
        customRender: (text, record, index) => {
          var html = (
            <div class="alink">
              <a
                href="javascript:;"
                onClick={() => this.showFlowlabel(true, record)}
              >
                {record.bxdh}
              </a>
            </div>
          )
          return html
        }
      },
      {
        title: '报修人',
        dataIndex: 'xm',
        align: 'center'
      },
      {
        title: '报修人联系方式',
        dataIndex: 'sjh',
        align: 'center'
      },
      {
        title: '维修员',
        dataIndex: 'wxryXm',
        align: 'center'
      }
    ]
    const columns2 = [
      {
        title: '序号',
        dataIndex: '_index',
        align: 'center'
      },
      {
        title: '单号',
        width: 120,
        align: 'center',
        customRender: (text, record, index) => {
          var html = (
            <div class="alink">
              <a
                href="javascript:;"
                onClick={() => this.showFlowlabel(true, record)}
              >
                {record.bxdh}
              </a>
            </div>
          )
          return html
        }
      },
      {
        title: '报修人',
        dataIndex: 'bxr',
        align: 'center'
      },
      {
        title: '维修员',
        dataIndex: 'wxyxm',
        align: 'center'
      },
      {
        title: '当前状态',
        dataIndex: 'dqzt',
        align: 'center'
      },
      {
        title: '已耗时',
        align: 'center',
        dataIndex: 'yhs'
      }
    ]
    const columns3 = [
      {
        title: '维修员',
        dataIndex: 'name',
        width: '200px',
        align: 'center'
      },
      {
        title: '接单量',
        dataIndex: 'total',
        width: '200px',
        align: 'center'
      }
    ]
    const columns4 = [
      {
        title: '维修员',
        dataIndex: 'name',
        width: '200px',
        align: 'center'
      },
      {
        title: '完成度',
        dataIndex: 'percent',
        width: '200px',
        align: 'center'
      }
    ]
    const columns5 = [
      {
        title: '维修员',
        dataIndex: 'name',
        width: '200px',
        align: 'center'
      },
      {
        title: '满意度',
        dataIndex: 'percent',
        width: '200px',
        align: 'center'
      }
    ]
    return {
      roleqx: {},
      stasetForm: this.$form.createForm(this),
      form: this.$form.createForm(this),
      tabtimes2: [
        {
          label: '最近30天',
          value: '30'
        },
        {
          label: '最近3个月',
          value: '90'
        },
        {
          label: '最近6个月',
          value: '180'
        },
        {
          label: '最近1年',
          value: '365'
        }
      ],
      columns,
      dataSource: [],
      columns2,
      dataSource2: [],
      PAGINATION2: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      columns3,
      dataSource3: [],
      columns4,
      dataSource4: [],
      columns5,
      dataSource5: [],
      columnsType: 1,
      visibleprease: false,
      current: {},
      nvaList: [],
      duty: '',
      dutyId: '',
      navspan: '',
      pieoneData: {},
      pieoneData2: {},
      stasetdates: {},
      fulldates: {},
      preaseData: {},
      bxdh: '',
      currentRowStatusText: ''
    }
  },
  mounted () {
    // 获取权限
    this.getRoles()
  },
  methods: {
    // 获取权限
    getRoles () {
      this.$axios.post('/api/roleMenu/getRoles.do').then(res => {
        if (!res.data.roles[0]) {
          this.$router.push({ path: '/403', query: {} })
        } else {
          this.roleqx = res.data.roles[0]
          // 头部显示
          this.typenav(res.data.roles[0].code)
          // 不满意
          this.fetchList(this.PAGINATION)
          // 维修时长
          this.fetchList2(this.PAGINATION2)
          // 饼图数据
          this.getpiedata()
          this.getpiedatatwo()
        }
      })
    },
    // 报修单状态统计
    typenav (id) {
      this.$axios.post('/api/gzt/bxdzt.do', { roleCode: id }).then(res => {
        var deswidth = 20 * (res.data.list.length - 1)
        // var widthper = calc(100% - /res.data.list.length
        this.navspan =
          'width:calc((100% - ' +
          deswidth +
          'px)/' +
          res.data.list.length +
          ')'
        this.nvaList = res.data.list || []
      })
    },
    // 不满意报修单
    fetchList (data) {
      let params = {
        sfswjxy: '0',
        ...data,
        currentPageNo: data.pageNum
      }
      this.$axios.post('/api/gzt/queryBmyBxjlPageAjax.do', params).then(res => {
        this.dataSource = res.rows || []
        const { pageNum, pageSize } = params
        this.PAGINATION = {
          total: res.total || 0,
          pageNum,
          pageSize
        }
      })
    },
    // 切换数据
    onChange (changeParams) {
      this.fetchList(this.getFetchParams(changeParams, this.PAGINATION))
    },
    getFetchParams (customParam, PAGINATION) {
      const { pageNum, isRemove } = customParam || {}
      let params = {
        ...PAGINATION,
        ...customParam
      }
      if (pageNum && params.pageNum) {
        params.pageNum = pageNum
      } else {
        params.pageNum = 1
        params.pageSize = 10
      }
      if (isRemove && params.pageNum && this.dataSource.length % 10 === 1) {
        params.pageNum = params.pageNum > 2 ? params.pageNum - 1 : 1
      }
      return params
    },
    // 维修时长
    fetchList2 (data) {
      let params = {
        ...data,
        currentPageNo: data.pageNum
      }
      this.$axios.post('/api/gzt/QueryhsjcbxdPageAjax.do', params).then(res => {
        this.dataSource2 = res.rows || []
        const { pageNum, pageSize } = params
        this.PAGINATION2 = {
          total: res.total || 0,
          pageNum,
          pageSize
        }
      })
    },
    // 切换数据
    onChange2 (changeParams) {
      this.fetchList2(this.getFetchParams(changeParams, this.PAGINATION2))
    },
    editansave (type) {
      this.columnsType = type
    },
    // 数据转化
    getDate (res) {
      var maindata = []
      for (var i = 0; i < res.data.list.labels.length; i++) {
        maindata.push({
          name: res.data.list.labels[i],
          value: res.data.list.colValues[0][i]
        })
      }
      var pieoneData = {
        text: res.data.list.labels,
        data: maindata,
        value: res.data.list.colValues[0]
      }
      return pieoneData
    },
    // 报修单状态
    getpiedata () {
      if (!this.stasetdates.startTime) {
        this.stasetdates = this.getselectDate(0)
      }
      let params = {
        ...this.stasetForm.getFieldsValue(),
        ...this.stasetdates,
        roleCode: this.roleqx.code
      }
      this.$axios.post('/api/gzt/gztDdzttj.do', params).then(res => {
        this.drawpie(this.getDate(res))
      })
    },
    // 维修人员状况
    getpiedatatwo () {
      // 接单情况
      this.$axios.post('/api/gzt/wxryJdqkAjax.do', {}).then(res => {
        this.dataSource3 = res.data.list
      })
      // 完成度
      this.$axios.post('/api/gzt/wxryWcd.do', {}).then(res => {
        this.dataSource4 = res.data.list
      })
      // 满意度
      this.$axios.post('/api/gzt/wxryMyd.do', {}).then(res => {
        this.dataSource5 = res.data.list
      })
    },
    drawpie (pieoneData) {
      let labels = {
        position: 'inside',
        formatter: '{b}({c})'
      }
      for (var i = 0; i < pieoneData.data.length; i++) {
        pieoneData.data[i].label = labels
      }
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('staseChart'))
      // 绘制图表
      myChart.setOption({
        color: [
          '#4472c4',
          '#ed7d31',
          '#a5a5a5',
          '#ffc000',
          '#5b9bd5',
          '#70ad47',
          '#264478',
          '#d33200',
          '#5252c1'
        ],
        title: {
          text: '',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        legend: {
          // orient: 'vertical',
          // top: 'middle',
          bottom: 40,
          left: 'center',
          data: pieoneData.text
        },
        series: [
          {
            type: 'pie',
            radius: '65%',
            center: ['50%', '35%'],
            selectedMode: 'single',
            data: pieoneData.data,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      })
    },
    // 查看更多/明细
    seeMore (formname) {
      let params = {}
      if (formname === 'stasetForm') {
        params = {
          ...this.stasetdates,
          ...this.stasetForm.getFieldsValue()
        }
      }
      this.$router.push({ path: '/repair', query: params })
    },
    // // 耗时较长
    // searchChange (value) {
    //   let params = {
    //     ...this.searchForm.setFieldsValue({ schoolCode: value })
    //   }
    //   params.schoolCode = value
    //   this.$nextTick(function () {
    //     this.fetchList()
    //   })
    // },
    // searchChange2 (value) {
    //   let params = {
    //     ...this.searchForm.setFieldsValue({ overTime: value })
    //   }
    //   this.$nextTick(function () {
    //     this.fetchList()
    //   })
    // },
    // 报修单状态
    stasetFormChange (value) {
      let params = {
        ...this.stasetForm.getFieldsValue(),
        ...this.stasetdates
      }
      params.schoolCode = value
      this.$nextTick(function () {
        this.getpiedata(params)
      })
    },
    // stasetFormChange2 (value) {
    //   if (!value) {
    //     value = 0
    //   }
    //   this.stasetdates = this.getselectDate(value)
    //   let params = {
    //     ...this.stasetForm.getFieldsValue(),
    //     ...this.stasetdates
    //   }
    //   this.$nextTick(function () {
    //     this.getpiedata(params)
    //   })
    // },
    getselectDate (days) {
      if (days === 0) {
        return { endTime: '', startTime: '' }
      }
      var myDate = new Date()
      var nowY = myDate.getFullYear()
      var nowM = myDate.getMonth() + 1
      var nowD = myDate.getDate()
      var enddate =
        nowY +
        '-' +
        (nowM < 10 ? '0' + nowM : nowM) +
        '-' +
        (nowD < 10 ? '0' + nowD : nowD) // 当前日期
      var lw = new Date(myDate - 1000 * 60 * 60 * 24 * days) // 最后一个数字30可改，30天的意思 days
      var lastY = lw.getFullYear()
      var lastM = lw.getMonth() + 1
      var lastD = lw.getDate()
      var startdate =
        lastY +
        '-' +
        (lastM < 10 ? '0' + lastM : lastM) +
        '-' +
        (lastD < 10 ? '0' + lastD : lastD) // days 天之前日期
      return { endTime: enddate, startTime: startdate }
    },
    // 查看流程
    showFlowlabel (visible, record) {
      this.bxdh = record.bxdh
      this.currentRowStatusText = record.dqzt
      this.$axios
        .post('/api/bxgl/queryBxlcByBxdh.do', {
          bxId: record.id,
          bxdh: record.bxdh
        })
        .then(res => {
          this.preaseData = res.data || []
          this.visibleprease = !!visible
        })
    },
    // 流程确定
    handleSubmitprease () {
      this.visibleprease = false
    },
    // 头部跳转
    jumptorepaire (status) {
      if (status === 'bmydl') {
        return false
      }
      this.$router.push({ path: '/repair', query: { type: status } })
    }
  }
}
</script>
